import { ReactNode } from 'react';
import { motion } from 'framer-motion';

interface Props {
  id: string;
  title: ReactNode;
  titleSuffix?: ReactNode;
  children: ReactNode;
  actions?: ReactNode;
}
export function AccountSettingsPanel({
  id,
  title,
  titleSuffix,
  children,
  actions,
}: Props) {
  return (
    <motion.section
      id={id}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, ease: 'easeOut' }}
      className="mb-0 w-full rounded border border-white/5 bg-white/[0.03] px-24 py-20 backdrop-blur-md shadow-2xl"
    >
      <div className="flex items-center gap-14 border-b border-white/5 pb-16">
        <div className="text-xl font-medium tracking-tight text-white/90">{title}</div>
        {titleSuffix && <div className="ml-auto">{titleSuffix}</div>}
      </div>
      <div className="pt-24">{children}</div>
      {actions && (
        <div className="mt-40 flex justify-end border-t border-white/5 pt-16">
          {actions}
        </div>
      )}
    </motion.section>
  );
}
